<template>
  <div v-if="src || showPlaceholder" class="selected-image-preview">
    <div class="selected-image-preview-label text-subtitle-2 font-weight-medium mb-2">{{ label }}</div>
    <v-card class="product-image-item selected-image-preview-card" flat hover>
      <div class="product-image-thumb-wrap selected-image-preview-image-wrap">
        <v-img
            v-if="src"
            :src="src"
            :alt="alt || label"
            class="product-image-thumb selected-image-preview-image"
            height="100%"
            cover
            eager
        ></v-img>
        <div v-else class="selected-image-preview-placeholder text-medium-emphasis">
          {{ placeholder }}
        </div>
      </div>
      <div class="selected-image-preview-actions">
        <v-btn color="error" variant="text" size="small" @click="$emit('remove')">Eemalda</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "SelectedImagePreview",
  props: {
    src: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Pildi eelvaade",
    },
    placeholder: {
      type: String,
      default: "Pilti pole valitud",
    },
    alt: {
      type: String,
      default: "",
    },
    height: {
      type: [Number, String],
      default: 220,
    },
    showPlaceholder: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['remove'],
};
</script>

<style scoped>
.selected-image-preview {
  width: 100%;
}

.selected-image-preview-card {
  width: 100%;
  max-width: 180px;
}

.selected-image-preview-label {
  text-align: left;
}

.selected-image-preview-image-wrap {
  aspect-ratio: 4 / 3;
}

.selected-image-preview-image {
  background: #f7f7f7;
}

.selected-image-preview-image :deep(.v-img__img) {
  object-fit: cover !important;
  object-position: center center !important;
}

.selected-image-preview-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  padding: 16px;
}

.selected-image-preview-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 0 0;
  flex-wrap: wrap;
}
</style>